var map = {
	"./Group 20995.png": 2207,
	"./LeftArrowCurved.png": 5694,
	"./LineSection12_1.png": 4829,
	"./LineSection12_2.png": 2601,
	"./arrow-down.png": 9065,
	"./arrow-up.png": 1669,
	"./backSection8.png": 325,
	"./backSection8Media.png": 9810,
	"./bigLogo.png": 2010,
	"./buttom.png": 3275,
	"./buttomMedia.png": 8186,
	"./close.png": 8968,
	"./cloud.png": 9693,
	"./colutionLogo.png": 3867,
	"./contactUsMobile.png": 3226,
	"./content.png": 7281,
	"./dollar.png": 661,
	"./dotsSectio12.png": 1066,
	"./elementorLogo.png": 9056,
	"./ellipse.png": 6911,
	"./explanation/1section6.png": 1461,
	"./explanation/green.png": 4175,
	"./explanation/pricing-background.png": 4226,
	"./explanation/pricing.png": 6221,
	"./explanation/section1.png": 8060,
	"./explanation/section10.png": 1576,
	"./explanation/section11.png": 4906,
	"./explanation/section12.png": 901,
	"./explanation/section13.png": 9009,
	"./explanation/section14.png": 9858,
	"./explanation/section14_1.png": 8858,
	"./explanation/section14_2.png": 7696,
	"./explanation/section15img.png": 5124,
	"./explanation/section2.png": 3096,
	"./explanation/section3.png": 3767,
	"./explanation/section4.png": 9621,
	"./explanation/section5.png": 7621,
	"./explanation/section6.png": 7080,
	"./explanation/section7.png": 694,
	"./explanation/section8.png": 5624,
	"./explanation/section9.png": 2368,
	"./goLogo.png": 3985,
	"./hand.png": 9807,
	"./homeScreen.png": 2832,
	"./homeScreenMobile.png": 1702,
	"./iphoneMedia.png": 6493,
	"./iphoneSection13.png": 4454,
	"./law.png": 1739,
	"./line.png": 2400,
	"./logo.png": 6338,
	"./magentLogo.png": 3485,
	"./magento-logo.png": 5394,
	"./magentoLogo.png": 4853,
	"./myLogo.png": 3850,
	"./nail.png": 2532,
	"./next.png": 5938,
	"./numbers-rtl.png": 8987,
	"./numbers.png": 9142,
	"./omega-logo.png": 8893,
	"./quickeSelling.png": 3394,
	"./section10.png": 8448,
	"./section12Circle.png": 6473,
	"./section15.png": 992,
	"./section15mobile.png": 1272,
	"./section1Mobile.png": 2709,
	"./section2men.png": 1657,
	"./section2menMedia.png": 9194,
	"./section6.png": 837,
	"./section6phone.png": 8491,
	"./section7men.png": 380,
	"./shopifyLogo.png": 8561,
	"./squarespaceLogo.png": 1426,
	"./star.png": 4260,
	"./support.png": 7194,
	"./templateLogo.png": 3836,
	"./termsAndCondition.png": 9472,
	"./threedLlogo.png": 585,
	"./trainer.png": 4287,
	"./video.png": 6736,
	"./vote.png": 8152,
	"./widgetIcon.png": 3340,
	"./wixLogo.png": 4492,
	"./wooLogo.png": 1021,
	"./yolkartLogo.png": 9784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7872;